import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { indiOrderNumberValidator } from 'src/app/general-components/form-controls/indi-order-number';
import { MancoSearchForm } from '../new-manco-form/manco-form-types';

@Component({
  selector: 'app-new-manco-search-form',
  templateUrl: './new-manco-search-form.component.html',
  styleUrls: ['./new-manco-search-form.component.scss'],
})
export class NewMancoSearchFormComponent implements OnInit {
  @Output() orderNumberEmitter = new EventEmitter<string>();
  @Output() freshdeskTicketNumberEmitter = new EventEmitter<string>();
  @Output() submitEmitter = new EventEmitter<void>();
  @Output() resetEmitter = new EventEmitter<void>();

  requiredValidator = Validators.required.bind(null);

  form: FormGroup<MancoSearchForm>;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) {
    this.form = this.fb.group<MancoSearchForm>({
      orderNumber: new FormControl('', {
        nonNullable: true,
        validators: [this.requiredValidator, indiOrderNumberValidator],
      }),
      freshdeskTicketNumber: new FormControl('', {
        nonNullable: true,
        validators: [this.requiredValidator, Validators.pattern('^[0-9]{1,7}$')],
      }),
    });
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.form.setValue({
        orderNumber: params.get('orderNumber') ?? '',
        freshdeskTicketNumber: params.get('freshdeskTicketNumber') ?? '',
      });
      this.onSubmit();
    });
  }

  onSubmit(): void {
    this.onReset();
    if (this.form.valid) {
      // TODO: Emit these values together inside the this.submitEmitter.emit(....);
      this.orderNumberEmitter.emit(this.form.value.orderNumber);
      this.freshdeskTicketNumberEmitter.emit(this.form.value.freshdeskTicketNumber);
      this.submitEmitter.emit();
    }
  }

  onReset(): void {
    this.resetEmitter.emit();
  }

  forceReset(): void {
    this.form.reset();
    this.resetEmitter.emit();
  }
}
